import React, { useMemo } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactDataTable from 'react-data-table-component';
import { avatar1, avatar10, avatar2, avatar3, avatar4, avatar6, avatar7, avatar8, avatar9 } from '../../assets/images';
import { IconEdit, IconEye, IconTrash } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

export default function ProjectList() {

    const columnsFilter = [
        {
            name: 'Project',
            selector: row => row.project,
            sortable: true,
            style: {
                fontWeight: "700"
            },
            width: "20%"
        },
        {
            name: 'Created',
            selector: row => row.created,
            sortable: true,
        },
        {
            name: 'Deadline',
            selector: row => row.deadline,
            sortable: true,
        },
        {
            name: 'Progress',
            selector: row => row.progress,
        },
        {
            name: 'Lead',
            selector: row => row.lead,
        },
        {
            name: 'Team',
            selector: row => row.team,
        },
        {
            name: 'Status',
            selector: row => row.status,
        },
        {
            name: 'Action',
            selector: row => row.action,
            width: '165px'
        },
    ];

    const dataFilter = [
        {
            project: 'iNext - One Page Responsive Template',
            created: '14 July, 2021',
            deadline: '22 Aug, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[29%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 29%
                    </small>
                </div>,
            lead: <img src={avatar1} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-sky text-white rounded'>InActive</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <Link to="/project-detail" title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </Link>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            project: 'InfiniO 4.1',
            created: '14 July, 2021',
            deadline: '8 Aug, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[48%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 48%
                    </small>
                </div>,
            lead: <img src={avatar2} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Active</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <button title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            project: 'InfiniO 4.1',
            created: '14 July, 2021',
            deadline: '05 Sept, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[48%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 48%
                    </small>
                </div>,
            lead: <img src={avatar3} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Active</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <button title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            project: 'InfiniO 4.2',
            created: '14 July, 2021',
            deadline: '25 Sept, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[48%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 48%
                    </small>
                </div>,
            lead: <img src={avatar4} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-warning text-white rounded'>Pending</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <button title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            project: 'Many desktop publishing packages and web',
            created: '18 July, 2021',
            deadline: '18 Aug, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[78%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 78%
                    </small>
                </div>,
            lead: <img src={avatar6} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar4} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Active</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <button title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            project: 'Many desktop publishing packages and web',
            created: '18 July, 2021',
            deadline: '15 Sept, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[78%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 78%
                    </small>
                </div>,
            lead: <img src={avatar7} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Active</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <button title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            project: 'Massive Event - Conference and Event',
            created: '18 July, 2021',
            deadline: '25 Sep, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[100%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 100%
                    </small>
                </div>,
            lead: <img src={avatar1} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-danger text-white rounded'>Closed</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <button title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            project: 'Oakleaf Admin - Bootstrap html5 with SASS',
            created: ' 18 July, 2021',
            deadline: '29 Aug, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[13%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 13%
                    </small>
                </div>,
            lead: <img src={avatar8} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Active</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <button title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            project: 'Startup - OnePage Business Corporate Template',
            created: '14 July, 2021',
            deadline: '26 Sep, 2021',
            progress:
                <div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                        <div className="progress-bar w-[56%] h-full bg-blue"></div>
                    </div>
                    <small>
                        Completion with: 56%
                    </small>
                </div>,
            lead: <img src={avatar9} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-lg' />,
            team:
                <ul className="flex items-center py-5">
                    <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                    <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar10} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
                </ul>,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-warning text-white rounded'>Pending</span>,
            action:
                <div className='flex items-stretch gap-10'>
                    <button title='mail' className='bg-success rounded-[4px] px-10 py-[8px]'>
                        <IconEye className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
    ]

    const [filterText, setFilterText] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const filteredItems = dataFilter.filter(
        item =>
            item.project.toLowerCase().includes(filterText.toLowerCase()) ||
            item.created.toLowerCase().includes(filterText.toLowerCase()) ||
            item.deadline.toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className='flex gap-5 mb-10 w-full justify-end'>
                <div className='relative w-full max-w-[221px]'>
                    <input
                        type='text'
                        id='search'
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        placeholder='Search here...'
                        className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
                    />
                </div>
                <button onClick={handleClear} className="btn btn-danger">
                    Clear
                </button>
            </div>
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <>
            <Breadcrumb title="Project List" path="Projects / Project List" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='react-data-table'>
                    <ReactDataTable
                        columns={columnsFilter}
                        data={filteredItems}
                        pagination
                        paginationResetDefaultPage={resetPaginationToggle}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                    />
                </div>
            </div>
        </>
    )
}
